// Parse enabled policy types once at module load
// Format: { F: true, H: true, A: true, C: true, R: true }
export const enabledPolicyTypes = JSON.parse(import.meta.env.VITE_AVAILABLE_POLICY_TYPES || '{}');

// Check if a policy type option is enabled based on environment config
// For composite types (e.g. "HA"), returns true if any constituent type is enabled
export const isPolicyTypeEnabled = (optionId) =>
  Object.entries(enabledPolicyTypes).some(([type, isEnabled]) => optionId.includes(type) && isEnabled);

export const checkIsFarmEnvironment = () => enabledPolicyTypes.F === true;
